import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { FormControl, Modal } from "react-bootstrap";
import TemplatesCategoryNewInline from "./TemplatesCategoryNewInline";
import TemplatesCategoryEditInline from "./TemplatesCategoryEditInline";

class TemplatesCategorySelect extends Component {
  static propTypes = {
    handleSave: PropTypes.func.isRequired,
    categories: PropTypes.array,
    email_template_category_id: PropTypes.number,
    handleSelectCategory: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    categoryId: PropTypes.number
  };

  constructor(props) {
    super(props);
    this.state = {
      categoryId: this.props.email_template_category_id,
      categoryName: this.categoryName(
        this.props.categories,
        this.props.email_template_category_id
      ),
      categories: this.props.categories,
      showEditActionModal: false,
      showNewActionModal: false
    };
  }

  closeEditActionModal() {
    this.setState({ showEditActionModal: false });
  }

  openEditActionModal() {
    this.setState({ showEditActionModal: true });
  }

  openEditAction(e) {
    e.preventDefault();
    this.openEditActionModal();
  }

  closeNewActionModal() {
    this.setState({ showNewActionModal: false });
  }

  openNewActionModal() {
    this.setState({ showNewActionModal: true });
  }

  openNewAction(e) {
    e.preventDefault();
    this.openNewActionModal();
  }

  handleChange(e) {
    let categoryId = Number(e.target.value);
    if (categoryId == 0) {
      categoryId = null;
    }
    this.setState({
      categoryId: categoryId,
      categoryName: this.categoryName(this.state.categories, categoryId)
    });
    this.props.handleSelectCategory(categoryId);
  }

  handleUpdateCategories(category, categories) {
    this.setState({
      categories: categories,
      categoryId: category.id,
      categoryName: this.categoryName(categories, category.id)
    });
    this.props.handleSelectCategory(category.id);
    this.closeNewActionModal();
    this.closeEditActionModal();
  }

  categoryOptions(categories) {
    if (categories) {
      let options = categories
        .sort((obj1, obj2) => {
          return obj1.name.localeCompare(obj2.name);
        })
        .map(category => {
          let selected = "";
          if (this.state.categoryId == category.id) {
            selected = "selected";
          }
          return (
            <option key={category.id} value={category.id} selected={selected}>
              {category.name}
            </option>
          );
        });
      return options;
    }
  }

  categoryName(categories, categoryId) {
    for (let category of categories) {
      if (categoryId == category.id) {
        return category.name;
      }
    }
  }

  editButton() {
    if (this.state.categoryId != null && this.state.categoryId != "0") {
      return (
        <button
          className="btn btn-xs btn-inverse pull-right edit_category_btn"
          onClick={this.openEditAction.bind(this)}
        >
          Edit
        </button>
      );
    }
  }

  render() {
    const { categoryId, handleSave } = this.props;
    return (
      <div style={{ display: "inline" }}>
        {this.editButton()}
        <button
          className="btn btn-xs btn-inverse pull-right new_category_btn"
          onClick={this.openNewAction.bind(this)}
        >
          New
        </button>
        <FormControl
          componentClass="select"
          type="select"
          className="form-control category_select"
          labelClassName=""
          wrapperClassName=""
          value={this.state.email_template_id}
          name="step_action"
          onChange={this.handleChange.bind(this)}
        >
          <option>Uncategorized</option>
          {this.categoryOptions(this.state.categories)}
        </FormControl>
        <Modal
          show={this.state.showEditActionModal}
          onHide={this.closeEditActionModal.bind(this)}
          backdrop="static"
          keyboard={false}
          autoFocus={true}
          enforceFocus={true}
        >
          <Modal.Header closeButton={true}>
            <Modal.Title id="contained-modal-title-lg">
              Edit Category
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <TemplatesCategoryEditInline
              match={this.props.match}
              categoryId={this.state.categoryId}
              categoryName={this.state.categoryName}
              handleUpdateTemplateCategoryId={this.handleUpdateCategories.bind(
                this
              )}
            />
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.showNewActionModal}
          onHide={this.closeNewActionModal.bind(this)}
          backdrop="static"
          keyboard={false}
          autoFocus={true}
          enforceFocus={true}
        >
          <Modal.Header closeButton={true}>
            <Modal.Title id="contained-modal-title-lg">
              New Category
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <TemplatesCategoryNewInline
              match={this.props.match}
              handleUpdateTemplateCategoryId={this.handleUpdateCategories.bind(this)}
            />
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default TemplatesCategorySelect;
